import Axios from "axios";
import { createTokenService } from "./TokenService";

let store = null;

export const injectStore = (_store) => {
  store = _store;
};

// // note:  instance axios.
// export function instance({ headers, baseURL }) {
//   return Axios.create({
//     baseURL, // note: base url
//     ...headers, // note: headers. headers is object. must be use spread operator to manipulate headers value.
//     withCredentials: true,
//   });
// }

// note: onLogout is app-defined
let onLogoutHandler = async (err) => {
  console.error("ON LOGOUT HANDLER ERROR: ", err);
};

// note: register on logout
export function registerOnLogout(fn) {
  onLogoutHandler = fn;
}

// note: ONE token service for the whole app, so concurrent 401s share a single
// note: refresh call (refreshPromise lock). refresh always hits REACT_APP_TENANT_BE.
const tokenService = createTokenService({
  baseURL: process.env.REACT_APP_TENANT_BE,
  onLogout: (err) => {
    onLogoutHandler(err);
  },
});

// note: one axios instance per baseURL, created lazily and reused.
const instances = new Map();

// note: instance
export function instance({ baseURL }) {
  if (!instances.has(baseURL)) instances.set(baseURL, createApi(baseURL));
  return instances.get(baseURL);
}

function createApi(baseURL) {
  const api = Axios.create({
    baseURL,
    withCredentials: true,
  });

  // note: attach Authorization
  api.interceptors.request.use(async (config) => {
    const token = tokenService.getAccessToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // config.headers["X-Company-Slug"] = headers["X-Company-Slug"];
    }

    if (store) {
      const state = store.getState();
      const companyId = state.user?.getProfile?.data?.company;
      if (companyId) {
        config.headers["x-company-id"] = companyId;
      }
    }

    return config;
  });

  // note: handle 401
  api.interceptors.response.use(
    (res) => res,
    async (error) => {
      const original = error.config;

      // not auth error? just reject
      if (error.response?.status !== 401) {
        // await notificationHandle({ error });

        return Promise.reject(error);
      }

      // note: prevent infinite loop
      if (original._retry) {
        // note: already retried once, now it's a real 401
        return Promise.reject(error);
      }
      original._retry = true;

      try {
        // note: wait for fresh token (this internally dedupes refresh calls)
        const newToken = await tokenService.getValidToken();

        // note: retry original with the new token
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      } catch (refreshErr) {
        console.error("REFRESH ERROR: ", refreshErr);
        //  note: refresh failed -> logout already handled in tokenService
        return Promise.reject(refreshErr);
      }
    },
  );

  return api;
}
